import moment, { Moment } from "moment";
import { Application, ApplicationDTO } from "models/application/Application";

export enum JobState {
  pending = "pending",
  inProgress = "in-progress",
  failed = "failed",
  successful = "successful",
  unknown = "unknown"
}

export enum JobTrigger {
  "manual" = "manual",
  "auto" = "auto",
  "technical" = "technical",
  "external" = "external"
}

export interface JobDto {
  id: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  name: string | null;
  trigger: JobTrigger | null;
  state: JobState;
  parentJob?: JobDto | null;
  handler: string | null;
  application?: ApplicationDTO | null;
  log?: string | null;
}

export class Job {
  private _id: number = 0;
  private _createdAt: Moment = moment();
  private _startedAt: Moment | null = moment();
  private _finishedAt: Moment | null = moment();
  private _state: JobState = JobState.unknown;
  private _name: string | null = null;
  private _trigger: JobTrigger | null = null;
  private _handler: string | null = null;
  private _log: string | null = null;
  private _parentJob: Job | null = null;
  private _application: Application | null = null;

  static create(job: JobDto) {
    const instance = new Job();

    instance._id = job.id;
    instance._createdAt = moment(job.createdAt);
    instance._startedAt = job.startedAt ? moment(job.startedAt) : null;
    instance._finishedAt = job.finishedAt ? moment(job.finishedAt) : null;
    instance._state = job.state;
    instance._name = job.name;
    instance._trigger = job.trigger;
    instance._handler = job.handler;
    instance._log = job.log || null;
    instance._parentJob = job.parentJob ? Job.create(job.parentJob) : null;
    instance._application = job.application
      ? Application.create(job.application)
      : null;

    return instance;
  }

  get id() {
    return this._id;
  }

  get createdAt() {
    return this._createdAt;
  }

  get startedAt() {
    return this._startedAt;
  }

  get finishedAt() {
    return this._finishedAt;
  }

  get parentJob() {
    return this._parentJob;
  }

  get application() {
    return this._application;
  }

  get name() {
    return this._name;
  }

  get trigger() {
    return this._trigger;
  }

  get state() {
    return this._state;
  }

  get handler() {
    return this._handler;
  }

  get log() {
    return this._log;
  }
}
